import React from 'react';
import { styled } from '@mui/system';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import Home from '@mui/icons-material/Home';
import Add from '@mui/icons-material/Add';
import History from '@mui/icons-material/History';
import { NavLink } from 'react-router-dom';
import PlainLink from '../../../components/util/PlainLink/PlainLink';

import { useSelector } from 'react-redux';

import { deleteAllCookies, isUser, isStudent } from '../../../app/util'

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'fixed',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-start',
}));

const DrawerItem = (props) => {
  return (
    <NavLink to={props.to} style={{ textDecoration: 'none', display: 'block', color: 'black' }}>
      <MenuItem onClick={props.clickEvent}>
        <ListItemIcon>
          <props.icon />
        </ListItemIcon>

        <ListItemText
          primary={props.text}
          primaryTypographyProps={{ style: { whiteSpace: "normal" } }}
        />
      </MenuItem>
    </NavLink>
  );
};

function NavBarOnTop() {
  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 610;
  React.useEffect(() => {
   const handleResizeWindow = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResizeWindow);
    return () => { window.removeEventListener("resize", handleResizeWindow); };
  }, []);

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const appState = useSelector((state)=>state.app);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  var drawerItems = [
    {
      "to": "/",
      "icon": Home,
      "text": "Home"
    },
    isUser(appState.me) && isStudent(appState.me) && {
      "to": "/user/application/create",
      "icon": Add,
      "text": "Apply Card Replacement"
    },
    isUser(appState.me) && isStudent(appState.me) && {
      "to": "/user/application/list",
      "icon": History,
      "text": "Application History"
    },
    {
      "icon": ExitToAppIcon,
      "text": "Logout",
      "clickEvent": () => { deleteAllCookies(); window.location.href = "/polyusso-logout" },
    }
  ];

  return (
    <div>
      <AppBar position="static">
        <Toolbar>
          <Typography noWrap variant="systemTitle">
            <PlainLink to="/">
              {
                width >= breakpoint
                ? "Application for Replacement of PolyU Student Identity Card"
                : "Application for Replacement of\nPolyU Student Identity Card"
              }
            </PlainLink>
          </Typography>
          {
            (!!appState.isLoggedIn)
            &&
            <IconButton
              color="inherit"
              aria-label="logout"
              edge="end"
              onClick={() => { deleteAllCookies(); window.location.href = "/polyusso-logout" }}
              style={{ margin: "0" }}
            >
              <ExitToAppIcon />
            </IconButton>
          }
          {
            (!!appState.isLoggedIn)
            &&
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="end"
              onClick={handleDrawerOpen}
              style={{ margin: "0" }}
            >
              <MenuIcon />
            </IconButton>
          }
        </Toolbar>
      </AppBar>
      <Drawer
        variant="temporary"
        anchor="right"
        open={open}
        onClose={handleDrawerClose}
        PaperProps={{
          sx: {
            width: {
              xs: 1,
              sm: 260
            }
          }
        }}
      >
        <Box
          role="presentation"
          onClick={handleDrawerClose}
          onKeyDown={handleDrawerClose}
        >
          <DrawerHeader>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
            <div style={{textAlign: 'end', lineHeight: 0, marginLeft: 'auto', marginTop: 25}}>
              <Typography variant="userInfo_Name">{appState?.me?.netid?.fullName}</Typography>
            </div>
          </DrawerHeader>
          <p style={{textAlign: 'end', lineHeight: 0, marginTop: 0}}>
            <Typography variant="userInfo_Details">{appState?.me?.user?.userId}</Typography>
          </p>
          <p style={{textAlign: 'end', lineHeight: 0, marginBottom: 30}}>
            <Typography variant="userInfo_Details">{appState?.me?.netid?.email}</Typography>
          </p>
          <Divider />
          <MenuList>
            {
              drawerItems.map((item, index) => (
                <DrawerItem key={index} to={item.to} icon={item.icon} text={item.text} clickEvent={item.clickEvent}/>
              ))
            }
          </MenuList>

        </Box>

      </Drawer>
    </div>
  );
}

export default NavBarOnTop;
